import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { AdminLogin } from "./AdminLogin";
import { AdminMenu } from "../components/AdminMenu";
import { AdminProdutos } from "./AdminProdutos";
import { CadastrarProduto } from "./CadastrarProduto";
import { Routes, Route } from "react-router-dom";
import { AdminPedidos } from "./AdminPedidos";
import { adminStore } from "../stores/AdminStore";
import { EditarProduto } from "./EditarProduto";
import { API_BASE_URL } from "../config";

export const AdminPage: React.FC = observer(() => {
  const setAccessToken = (token: string | null) => {
    adminStore.accessToken = token;
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}/gerenciar/refresh-token`, {
      method: "POST",
      credentials: "include",
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => setAccessToken(data.accessToken))
      .catch(() => setAccessToken(null));
  }, []);

  if (!adminStore.accessToken) {
    return <AdminLogin />;
  }

  return (
    <div>
      <AdminMenu />
      <Routes>
        <Route path="produtos" element={<AdminProdutos />} />
        <Route path="novoProduto" element={<CadastrarProduto />} />
        <Route path="pedidos" element={<AdminPedidos />} />
        <Route path="/editarProduto/:id" element={<EditarProduto />} />
      </Routes>
    </div>
  );
});
